import { useTranslation } from 'react-i18next';
import type { MessageResponse } from '@/api';
import { Tag } from '@/components/Ui/Tag';
import { verdictLabel, verdictOf } from '@/lib/messages';
import { useRustyState } from '@/state';

/** `filterOn` overrides the forms summary, for pages that already know the form. */
export function VerdictTag({
  message,
  filterOn,
}: {
  message: MessageResponse;
  filterOn?: boolean;
}) {
  const { t } = useTranslation();
  const summaryFilter = useRustyState(
    (s) => s.formsSummary?.find((f) => f.id === message.form_id)?.filter_spam
  );
  const verdict = verdictOf(message, filterOn ?? summaryFilter);
  const { key, values } = verdictLabel(verdict);
  const variant =
    verdict.kind === 'encrypted' ? 'enc' : verdict.kind === 'spam' ? 'risk' : 'neutral';
  return <Tag variant={variant}>{t(key, values)}</Tag>;
}
